import KnowledgeBaseAccessSchema, { KnowledgeBaseAccessJSON, KnowledgeBaseAccessParams } from "permissions/resources/knowledge-base/knowledge-base-access-schema";
import { Resource } from "permissions/resources/permission-resource";
import { registerResource } from "permissions/resources/resource-registry";
import { AccessLevel, AnyResourceJSON, ResourceFromJSON, ResourceType, Scope } from "permissions/resources/types";

export class KnowledgeBaseAccess extends Resource {
  public static create(params?: KnowledgeBaseAccessParams): KnowledgeBaseAccess {
    const parsed = KnowledgeBaseAccessSchema.validate(params);
    return new KnowledgeBaseAccess(parsed);
  }

  public static fromJSON<J extends AnyResourceJSON>(json: J): ResourceFromJSON<J> {
    const parsed = KnowledgeBaseAccessSchema.deserialize(json as KnowledgeBaseAccessJSON);
    return new KnowledgeBaseAccess(parsed) as ResourceFromJSON<J>;
  }

  public static getPermutations(): KnowledgeBaseAccess[] {
    const fieldIterations: [key: string, value: number[]][] = [
      ['accessLevel', Object.values(AccessLevel).filter((key) => !Number.isNaN(Number(key))).map(value => Number(value))],
      ['scope', Object.values(Scope).filter((key) => !Number.isNaN(Number(key))).map(value => Number(value))],
    ];
    return this.generatePermutations(KnowledgeBaseAccess, fieldIterations) as KnowledgeBaseAccess[];
  }

  public readonly resourceType = ResourceType.KnowledgeBaseAccess;
  public readonly accessLevel?: AccessLevel;
  public readonly scope?: Scope;

  public constructor(params?: KnowledgeBaseAccessParams) {
      super(params);
  
      if (params) {
        this.accessLevel = params.accessLevel;
        this.scope = params.scope;
      }
    }

  public toJSON(): KnowledgeBaseAccessJSON {
    return KnowledgeBaseAccessSchema.serialize(this);
  }

  public override toString(): string {
    return `KnowledgeBaseAccess {
      resourceType: ${this.resourceType}
      isDisabled: ${this.isDisabled ? 'true' : 'false'}
      resourceTypeText: ${this.resourceTypeText}
      accessLevel: ${this.accessLevel}
      scope: ${this.scope}
    }`
  }
}

registerResource("KnowledgeBaseAccess", (json) => KnowledgeBaseAccess.fromJSON(json));
